/**
 * Poll Stripe until PaymentIntent succeeds or reaches a terminal failure state.
 * ACSS / bank debits often return `processing` from confirmPayment until verification finishes.
 */
export async function waitForPaymentIntentSucceeded(
	stripe,
	clientSecret,
	options = {},
) {
	const {
		maxAttempts = 40,
		intervalMs = 1500,
		shouldAbort = () => false,
	} = options;

	let lastPaymentIntent = null;

	for (let i = 0; i < maxAttempts; i += 1) {
		if (shouldAbort()) {
			return { aborted: true };
		}

		await new Promise((resolve) => {
			setTimeout(resolve, intervalMs);
		});

		if (shouldAbort()) {
			return { aborted: true };
		}

		const { paymentIntent, error } = await stripe.retrievePaymentIntent(
			clientSecret,
		);

		if (error) {
			return { error };
		}

		if (!paymentIntent) {
			continue;
		}

		lastPaymentIntent = paymentIntent;

		if (paymentIntent.status === 'succeeded') {
			return { paymentIntent };
		}

		if (
			paymentIntent.status === 'canceled' ||
			paymentIntent.status === 'requires_payment_method'
		) {
			return { paymentIntent, failed: true };
		}
	}

	return { timeout: true, paymentIntent: lastPaymentIntent };
}
